export default __webpack_public_path__ + "static/media/Share-white.affc7e5c.svg";